<form [formGroup]="customUnitForm" (ngSubmit)="create()">
  <div class="modal-content w-100 h-100 d-flex flex-column justify-content-between">
    <apm-section-title title="{{ (isUta ? '445302' : '445301') | apmTranslate }}"></apm-section-title>
    <div class="custom-unit-content ps-1">
      <div class="row mb-3">
        <div class="col-12 col-lg-8">
          <div class="input-title">
            <label for="name">{{ '445303' | apmTranslate }}* </label>
            <input
              class="w-100 apm-input error"
              id="name"
              type="text"
              [ngClass]="{ error: customUnitForm.get('name')?.errors && customUnitForm.get('name')?.touched }"
              formControlName="name"
            />
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <label for="productionSite">{{ 451807 | apmTranslate }}</label>
          <apm-select
            id="productionSite"
            [useResourceTemplate]="true"
            [items]="productionSites()"
            bindLabel="resourceId"
            bindValue="code"
            formControlName="productionSiteCode"
          ></apm-select>
        </div>
      </div>
      <div class="row mb-3">
        <div [class]="isUta ? 'col-12' : 'col-6'">
          <label for="segmentId">{{ '445304' | apmTranslate }}*</label>
          <apm-select
            id="segmentId"
            [useResourceTemplate]="true"
            [items]="segments$ | async"
            bindLabel="descriptionId"
            bindValue="id"
            formControlName="segmentId"
          ></apm-select>
        </div>
        @if (!isUta) {
          <div class="col-6">
            <label for="brandId">{{ '445305' | apmTranslate }}*</label>
            <apm-select
              id="brandId"
              [useResourceTemplate]="true"
              [items]="brands$ | async"
              bindLabel="descriptionId"
              bindValue="id"
              formControlName="brandId"
            ></apm-select>
          </div>
        }
      </div>
      @if (!isUta) {
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-title">
              <label for="sapOfferNumber">{{ '445312' | apmTranslate }}</label>
              <input
                class="w-100 apm-input error"
                id="sapOfferNumber"
                type="text"
                [ngClass]="{
                  error: customUnitForm.get('sapOfferNumber')?.errors && customUnitForm.get('sapOfferNumber')?.touched,
                }"
                formControlName="sapOfferNumber"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="input-title">
              <label for="positionCode"
                >{{ '445310' | apmTranslate }}
                @if (customUnitForm.get('positionCode')?.errors?.required ?? false) {
                  <span>*</span>
                }
              </label>
              <input
                class="w-100 apm-input error"
                id="positionCode"
                type="number"
                [ngClass]="{
                  error: customUnitForm.get('positionCode')?.errors && customUnitForm.get('positionCode')?.touched,
                }"
                formControlName="positionCode"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-title">
              <label for="commodityCode"
                >{{ '445308' | apmTranslate }}{{ hasCustomAndRfqManagePermission ? '*' : '' }}
              </label>
              <input
                class="w-100 apm-input error"
                id="commodityCode"
                type="text"
                [ngClass]="{
                  error: customUnitForm.get('commodityCode')?.errors && customUnitForm.get('commodityCode')?.touched,
                }"
                formControlName="commodityCode"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="input-title">
              <label for="materialCode"
                >{{ '445309' | apmTranslate }}{{ hasCustomAndRfqManagePermission ? '*' : '' }}
              </label>
              <input
                class="w-100 apm-input error"
                id="materialCode"
                type="text"
                [ngClass]="{
                  error: customUnitForm.get('materialCode')?.errors && customUnitForm.get('materialCode')?.touched,
                }"
                formControlName="materialCode"
              />
            </div>
          </div>
        </div>
      }
      <div class="row">
        @if (!isUta) {
          <div class="col-6 mb-3">
            <div class="input-title">
              <label for="atpCode">{{ '445307' | apmTranslate }} </label>
              <input
                class="w-100 apm-input error"
                id="atpCode"
                type="text"
                [ngClass]="{ error: customUnitForm.get('atpCode')?.errors && customUnitForm.get('atpCode')?.touched }"
                formControlName="atpCode"
              />
            </div>
          </div>
        }
        <div class="col-6 mb-3">
          <div class="input-title">
            <label for="validityDate"
              >{{ '445313' | apmTranslate }}{{ !isUta && hasCustomAndRfqManagePermission ? '*' : '' }}
            </label>
            <apm-datepicker class="w-100" id="validityDate" formControlName="validityDate"></apm-datepicker>
          </div>
        </div>
        @if (isUta || hasCustomAndRfqManagePermission) {
          <div class="mb-3" [ngClass]="isUta ? 'col-6' : 'col-12'">
            <div class="input-title">
              <label for="priceList">{{ '445311' | apmTranslate }}{{ !isUta ? '*' : '' }} </label>
              <apm-currency-input
                id="priceList"
                [currencyMask]="{ prefix: currencySymbol + ' ' }"
                additionalClass="w-100 apm-input {{
                  customUnitForm.get('priceList')?.errors && customUnitForm.get('priceList')?.touched ? 'error' : ''
                }}"
                formControlName="priceList"
              ></apm-currency-input>
            </div>
          </div>
        }
      </div>
    </div>
    @if (!dialogData.readonly) {
      <div class="row mt-4">
        <div class="col-6">
          <apm-button variant="secondary" (click)="closeDialog()">{{ '444714' | apmTranslate }}</apm-button>
        </div>
        <div class="col-6">
          <apm-button class="w-100" type="submit" [disabled]="customUnitForm.invalid">{{
            '444735' | apmTranslate
          }}</apm-button>
        </div>
      </div>
    } @else {
      <div class="mt-4">
        <apm-button variant="secondary" (click)="closeDialog()">{{ '444714' | apmTranslate }}</apm-button>
      </div>
    }
  </div>
</form>
